import { render, staticRenderFns } from "./AttentionEventManage.vue?vue&type=template&id=bd8667b6&scoped=true&"
import script from "./AttentionEventManage.vue?vue&type=script&lang=js&"
export * from "./AttentionEventManage.vue?vue&type=script&lang=js&"
import style0 from "./AttentionEventManage.vue?vue&type=style&index=0&id=bd8667b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8667b6",
  null
  
)

export default component.exports